
<template>
    <TsCard
        dataTestid="faq_page_track_order"
        appendClass="py-1 bg-idle-white"
        class="rounded-lg"
        no-shadow
    >
        <TsRow isMultiline class="md:items-center">
            <TsColumn class="max-md:is-12">
                <TsRow class="md:items-center">
                    <TsColumn v-if="props.image" class="max-md:is-6 is-2">
                        <TsCard :noBorder="isMobile" noShadow appendClass="m-0 p-0 md:bg-white">
                            <TsImage v-if="props.image" class="max-md:w-full rounded-lg"
                                     width="280"
                                     height="280"
                                     :src="props.image" alt="faq-img-2" loading="lazy"/>
                        </TsCard>
                    </TsColumn>

                    <TsColumn v-if="props.title || props.description" class="max-md:is-6 is-8">
                        <TsTypography v-if="props.title" as="div" variant="h3" append-class="mb-0">
                          <div v-html="props.title"></div>
                        </TsTypography>
                        <TsTypography v-if="props.description">
                          <div v-html="props.description"></div>
                        </TsTypography>
                    </TsColumn>
                </TsRow>
            </TsColumn>

            <TsColumn v-if="props.buttonLabel" append-class="max-md:is-12 is-3 lg:flex lg:justify-end">
                <TsButton
                    block
                    append-class="lg:max-w-max lg:px-11"
                    dataTestid="faq_track_button"
                    :link="props.buttonLink"
                    :label="props.buttonLabel"
                />
            </TsColumn>
        </TsRow>
    </TsCard>
</template>

<script setup lang="ts">
const { isMobile } = useDevice();

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

type Props={
  image?: string;
  title?: string;
  description?: string;
  buttonLabel?: string;
  buttonLink?: string;
}

const props = withDefaults(defineProps<Props>(), {
  image: '/images/trackOrderFaq.png',
  title: 'Volg uw bestelling',
  description: 'Blijf op de hoogte van elke stap die uw pakket zet op weg naar u.',
  buttonLabel: 'Volg Bestelling',
  buttonLink:'/account/order-history'
});
</script>
